import { render, staticRenderFns } from "./ManageInvitesAbrSection.vue?vue&type=template&id=582a20f4&scoped=true&"
import script from "./ManageInvitesAbrSection.vue?vue&type=script&lang=js&"
export * from "./ManageInvitesAbrSection.vue?vue&type=script&lang=js&"
import style0 from "./ManageInvitesAbrSection.vue?vue&type=style&index=0&id=582a20f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a20f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VRow})
